import gql from 'graphql-tag';

export const SHOP_FOR_APP = gql`
  query shopForApp {
    shop {
      domain {
        url
      }
      name
      description
      headerText
      codAvailableLowerLimit
      codAvailableUpperLimit
      reviewRewardAmount
      reviewRewardAmountWithImage
      firstReviewRewardAmount
      referralPointAmount
      referralPointLimit
      firstImagePostRewardAmount
      purchaseLimit
      mgsShippingMethod {
        id
        maximumOrderWeight {
          unit
          value
        }
        prices(first: 100) {
          edges {
            node {
              id
              price {
                currency
                amount
              }
              startOrderWeight {
                unit
                value
              }
              stopOrderWeight {
                unit
                value
              }
            }
          }
        }
      }
    }
  }
`;

export const ME_FOR_APP = gql`
  query meForApp {
    me {
      id
      maccaronCart: cart(forMgs: false) {
        token
        quantity
        forMgs
      }
      mgsCart: cart(forMgs: true) {
        token
        quantity
        forMgs
      }
      zendeskToken
    }
  }
`;

export const ME_EMAIL_VERIFIED = gql`
  query meEmailVerified {
    me {
      emailVerified
    }
  }
`;

export const CATEGORY_FOR_APP = gql`
  query categoryForApp {
    categories(level: 2, first: 300) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
